import { atkEquipmentApi } from "common/state/portalApi/atkEquipment";
import { Button } from "@mui/material";
import { CarbonDataGrid } from "portal/components/CarbonDataGrid";
import { editArchetypesStatement } from "./permissions";
import {
  EquipmentSubpath,
  getEditImplementArchetypePath,
  Path,
} from "portal/utils/routing";
import { Header } from "portal/components/header/Header";
import { ImplementArchetype } from "protos/atk/autotractor";
import { NoScroll, Page } from "portal/components/Page";
import { UnauthorizedPage } from "portal/components/UnauthorizedPage";
import { useNavigate } from "react-router";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import AddIcon from "@mui/icons-material/Add";
import React, { useMemo } from "react";

const _ImplementArchetypeLibraryPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: archetypePages, isFetching: archetypesFetching } =
    useQueryPopups(
      atkEquipmentApi.endpoints.searchInfiniteImplementArchetypes.useInfiniteQuery(
        {}
      )
    );
  const archetypes = useMemo(
    () => (archetypePages?.pages ?? []).flatMap((page) => page.archetypes),
    [archetypePages?.pages]
  );

  return (
    <Page>
      <Header
        title={t("views.autotractor.equipment.implementArchetypeLibrary")}
        parentLink={Path.EQUIPMENT}
      />
      <NoScroll>
        <div className="flex flex-col items-end gap-2">
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() =>
              navigate(
                `${Path.EQUIPMENT}${EquipmentSubpath.CREATE_IMPLEMENT_ARCHETYPE}`
              )
            }
          >
            {t("views.autotractor.equipment.implements.newImplementArchetype")}
          </Button>
          <CarbonDataGrid<ImplementArchetype>
            columns={[
              {
                disableColumnMenu: true,
                flex: 1,
                field: "make",
                headerName: t("models.equipment.make", { count: 1 }),
              },
              {
                disableColumnMenu: true,
                flex: 1,
                field: "series",
                headerName: t("models.equipment.series"),
              },
              {
                disableColumnMenu: true,
                flex: 1,
                field: "model",
                headerName: t("models.equipment.model", { count: 1 }),
              },
            ]}
            rows={archetypes}
            loading={archetypesFetching}
            getRowId={(archetype) => archetype.id}
            getRowClassName={() => "cursor-pointer"}
            onRowClick={({ row: archetype }) =>
              navigate(getEditImplementArchetypePath(archetype.id))
            }
            className="w-full"
          />
        </div>
      </NoScroll>
    </Page>
  );
};

export const ImplementArchetypeLibraryPage = withAuthorizationRequired(
  editArchetypesStatement,
  _ImplementArchetypeLibraryPage,
  <UnauthorizedPage />
);
